import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class Interface {
  constructor () {
    instance = instance || this

    this._table = DB.interface

    return instance
  }

  /**
   * @param [string] data.name
   * @param [string] data.type
   * @param [string] data.args
   *
   * @returns [number] device id
   */
  async add (data) {
    return this._table.add({
      id: newGuid(),
      name: data.name,
      type: data.type,
      args: data.args
    })
  }

  async get (id) {
    return this._table.get(id)
  }

  async update (id, data) {
    return this._table.update(id, data)
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async all (type = '*') {
    if (type === '*') {
      return this._table.toArray()
    } else {
      return this._table.where({ type }).toArray()
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/interface.js